<template>
  <basicContainer>
    <view-form ref="viewForm" :view-form-data="viewFormData">
    </view-form>
  </basicContainer>
</template>


<script>
import {
  loadJs,
  changeFormModelUsingTaskForm,
  setHeaderBeforeFileUpload,
  controlHideByCondition,
  uploadBefore,
  uploadAfter,
  changeConfigToForm,
  setMode,
  donwloadFileOnClick,
  modifyFormModelData,
  cascadeLocal
} from "@/workFlow/utils/formUtil";
import {
  getToken
} from "@/framework/util/auth";

import viewForm from '@/workFlow/formComponent/viewForm/ViewForm.vue'

export default {
  components: {
    viewForm
  },
  data() {
    return {
      viewFormData: {
        options: {},
        modeldata: {},
        pageKey: '',
        row: {}
      }
    }
  },

  mounted() {
    let {
      row,
      pageKey
    } = this.$route.params
    if (!(row && pageKey)) {
      this.$message.error('缺失参数,请联系管理员')
      this.$router.push({
        path: '/404'
      })
    }
    this.viewFormData.pageKey = pageKey
    if (pageKey === 'VIEW') //查看的表单
    {
      this.getViewFormData(row)
    } else if (pageKey === 'DO') //办理表单
    {
      this.getTodoFormData(row)
    }

  },

  methods: {

    getTodoFormData(row) {
      this.row = row
      this.$http.get('/form-instance/select', {
        params: {
          dataId: row.businessKey,
          formId: row.taskFormKey[0]
        }
      }).then(response => {
        this.modeldata = response.data
        this.modeldata.processInstanceId = row.processInstanceId
        this.modeldata.taskId = row.taskId
        this.$http.get("/flow-ext/todo-task-description", {
          params: {
            businessKey: row.businessKey,
            taskId: row.taskId
          }
        }).then(response => {
          if (response.code === 200) {
            console.log('todo-task-description')
            console.log(response)

            //this.tableVisible = false
            if (response.data.formKeyList.length === 1) {
              this.signData.isSign = false
            } else if (response.data.formKeyList.length > 1) { //会签模式数据保存
              this.signData.isSign = true
              this.signData.data = response.data
            }
            let formModelJson = response.data.formModelJsonList
            let taskFormJson = response.data.taskFormPropertyList
            changeFormModelUsingTaskForm(formModelJson[0], taskFormJson)
            loadJs(formModelJson[0])
            this.options = formModelJson[0]
            setHeaderBeforeFileUpload(this.options, getToken()) //设置文件上传时的token
            setTimeout(() => {
              this.viewFormData.options = this.options
              this.viewFormData.modeldata = this.modeldata
              this.viewFormData.pageKey = 'DO'
              this.viewFormData.row = row
              this.formvisible = true
            }, 600)

          } else {
            this.$message.error(response.code + response.msg)
          }

        }).catch(err => {
          this.$message.error(err.code + err.msg)
        })

      }).catch(err => {
        this.$message.error(err.code + err.msg)
      })


    },

    getViewFormData(row) {
      if (row.form_KEY_ && row.form_KEY_.length > 0) {
        if (row.taskName === '已完成') {
          this.$message.info('任务已完成')
          return
        }
        this.getFormData(row.form_KEY_, row.id, row)

      } else {
        this.$http.get('/flow-ext/process-form-key', {
          params: {
            'processInstanceId': row.processInstanceId
          }
        }).then(response => {
          this.getFormData(row.businessKey, response.data, row)
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      }
    },
    getFormData(businessKey, formId, row) {
      this.$http.get('/form-model/detail', {
        params: {
          'formId': formId
        }
      }).then(response => {
        if (response.code === 200) {
          for (let i = 0; i < response.data.modelJson.column.length; i++) {
            response.data.modelJson.column[i].disabled = true
          }
          this.options = response.data.modelJson
          loadJs(this.options)
          changeFormModelUsingTaskForm(this.options, [])
          this.$http.get('/form-instance/select', {
            params: {
              'dataId': businessKey,
              'formId': formId
            }
          }).then(response => {
            if (response.code === 200) {

              console.log('response')
              console.log(response)
              setTimeout(() => {
                this.modeldata = response.data
                this.viewFormData.options = this.options
                this.viewFormData.modeldata = this.modeldata
                this.viewFormData.modeldata.processInstanceId = row.processInstanceId
                this.viewFormData.modeldata.taskId = row.taskId
                this.viewFormData.pageKey = 'VIEW'
                this.viewFormData.row = row
                this.formvisible = true
                /*setTimeout(() => {
                    changeConfigToForm(document.getElementsByTagName('label'), this.viewFormData.options)
                },600)*/
              }, 600)
            } else {
              this.$message.error(response.code + response.msg)
            }
          }).catch(error => {
            this.$message.error(error.msg || error.message)
          })
        } else {
          this.$message.error(response.code + response.msg)
        }
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      })
    },
  }

}
</script>
<style lang="scss" scoped>
:deep(.drawer-foot) {
  position: absolute;
  /*bottom: 0;
        left: 0;
        right: 0;*/
  margin-top: 20px; //display: flex;
  button {
    width: 50%;
  }
}

.audit_step {
  position: absolute;
  top: 150px;
  right: 10px;
  left: 820px;
  margin-bottom: 10px;
  background-color: white;
  z-index: 90;
}

.button-top {
  text-align: right;
  position: absolute;
  top: 35px;
  right: 23px;
  display: flex;
  z-index: 90;
}

.drawer-top {
  position: relative;
  height: 60px;
  margin-top: 50px;
  text-align: center;
}

:deep(.preview-form) {
  padding-top: 20px;
  /*overflow-y: auto;*/
  padding-bottom: 20px;
  height: 90%;
}

:deep(.avue-crud) {
  padding-bottom: 18px;
}

.bold_input :deep(.el-input__inner) {
  font-weight: bolder !important;
}

:deep(.el-textarea__inner) {
  font-weight: bolder !important;
}
</style>
